import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import AddIcon from "@material-ui/icons/Add";
import { actions } from "../../../redux/actions/alert";
import styles from "../../../styles/global-styles";
import Transition from "../../stateless/Transition";
import { ClientService } from "../../../services/client.service";

const usetSyles = makeStyles(() => ({
  typography: {
    fontWeight: 400,
    marginBottom: 8,
    color: "#1C2668",
    opacity: 0.5,
  },
  chip: styles.chip,

  label: {
    marginBottom: "1.5vh",
  },
  backgroundIcon: styles.backgroundIcon,
  rightButton: styles.buttonRightHeader,
}));

const NewClientModal = ({
  addAlert,
  detailAlert,
  open,
  onClose,
  newClientCreated,
}) => {
  const classes = usetSyles();
  const handleClose = () => onClose();

  const [clientObject, setclientObject] = useState({});

  const handleInputText = ({ target: { name, value } }) => {
    setclientObject({ ...clientObject, [name]: value });
  };

  const handleSubmitForm = async () => {
    onClose();
    try {
      const { status, data } = await ClientService.createClient(clientObject);
      if (status === 201) {
        const { id, name, email, telephone } = data;
        const client = { id, name, email, telephone };
        newClientCreated(true, "Cliente creado exitosamente", client);
      } else newClientCreated(false, "Error al dar de alta nuevo cliente");
    } catch (error) {
      console.log("error", error);
      newClientCreated(false, error.msgs);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Agregar nuevo cliente
      </DialogTitle>

      <DialogContent>
        <ValidatorForm
          noValidate
          onKeyPress={(event) => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }
          }}
          className={classes.form}
          method="POST"
          onSubmit={handleSubmitForm}
          onError={(errors) => console.log(errors)}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={8}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Nombre del cliente
                </Typography>
                <TextValidator
                  className={classes.textField}
                  fullWidth
                  name="name"
                  value={clientObject.name || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El nombre del cliente es requerido"]}
                  variant="outlined"
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={8}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Email
                </Typography>
                <TextValidator
                  className={classes.textField}
                  fullWidth
                  name="email"
                  value={clientObject.email || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El email es requerido"]}
                  variant="outlined"
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={8}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Teléfono
                </Typography>
                <InputMask
                  mask="9999999999"
                  maskChar=""
                  value={clientObject.telephone || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.textField}
                      name="telephone"
                      fullWidth
                      validators={["required"]}
                      errorMessages={["El teléfono del cliente es requerido"]}
                      variant="outlined"
                    />
                  )}
                </InputMask>
              </Box>
            </Grid>

            <Grid item>
              <Button
                color="primary"
                style={{ marginRight: 50, width: 150 }}
                onClick={() => onClose()}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                className={classes.rightButton}
                variant="contained"
                color="primary"
                type="submit"
                style={{ margin: 50, width: 150 }}
                endIcon={
                  <AddIcon className={classes.backgroundIcon} color="primary" />
                }
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(NewClientModal);
